import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"
import { slimSelectSettings } from "../helpers/slim_select_helpers"

// Wraps a <select> in SlimSelect and resolves its options from the server as
// the user types, so large datasets (e.g. thousands of employees) are never
// loaded into the DOM all at once. The select is rendered server-side with a
// first page of options for instant browsing; typing fetches matches from the
// JSON endpoint given via data-remote-select-url-value.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.slimselect = new SlimSelect({
      select: this.element,
      settings: slimSelectSettings({
        searchPlaceholder: "Suchen",
        searchText: "Keine Mitarbeiter gefunden",
        placeholderText: this.element.dataset.placeholder || "Auswählen",
        allowDeselect: true,
        closeOnSelect: !this.element.getAttribute("multiple"),
      }),
      events: {
        // A cleared search reaches this callback too (slim-select ≥ 4.4): keep the list as it was.
        search: (search, _selected, catalog) =>
          search === "" ? catalog : this.fetchOptions(search),
      },
    })
  }

  disconnect() {
    this.slimselect.destroy()
  }

  async fetchOptions(search) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", search)

    const response = await fetch(url, {
      headers: { Accept: "application/json" },
    })

    if (!response.ok) {
      throw new Error(`Server responded with status ${response.status}`)
    }

    return await response.json()
  }
}
